module.exports = __webpack_public_path__ + "img/yiwen.4e105581.gif";